import React, { useState } from 'react';
import './ManagerApproval.css';

const ManagerApproval = ({ requestData, onApproval }) => {
  const [budgetCode, setBudgetCode] = useState('');
  const [actionTaken, setActionTaken] = useState(null); // null, 'approved', or 'rejected'

  const handleApprove = () => {
    if (!budgetCode) {
      alert('Please enter a budget code');
      return;
    }

    setActionTaken('approved');
    onApproval({
      requestId: requestData.requestId,
      approved: true,
      approver: 'Sarah Johnson',
      budgetCode: budgetCode,
      timestamp: new Date()
    });
  };

  const handleReject = () => {
    setActionTaken('rejected');
    onApproval({
      requestId: requestData.requestId,
      approved: false,
      approver: 'Sarah Johnson',
      timestamp: new Date()
    });
  };

  const getOsLabel = (os) => {
    const labels = {
      ubuntu: 'Ubuntu 22.04 LTS',
      windows: 'Windows Server 2022',
      rhel: 'Red Hat Enterprise Linux 9'
    };
    return labels[os] || os;
  };

  const getSizeLabel = (size) => {
    const labels = {
      small: 'Small (2 vCPU, 4GB RAM)',
      medium: 'Medium (4 vCPU, 8GB RAM)',
      large: 'Large (8 vCPU, 16GB RAM)'
    };
    return labels[size] || size;
  };

  return (
    <div className="manager-approval">
      <div className="teams-header">
        <div className="teams-logo">
          <span className="teams-icon">📧</span>
          <h2>Microsoft Teams</h2>
        </div>
        <div className="manager-info">
          <span className="manager-name">Sarah Johnson</span>
          <span className="manager-role">Engineering Manager</span>
        </div>
      </div>

      <div className="approval-container">
        {!requestData ? (
          <div className="no-requests">
            <div className="empty-state">
              <span className="empty-icon">📭</span>
              <h3>No Pending Approvals</h3>
              <p>Waiting for approval requests from your team...</p>
            </div>
          </div>
        ) : actionTaken === 'approved' ? (
          <div className="approval-complete">
            <div className="success-message">
              <span className="success-icon">✅</span>
              <h3>Request Approved</h3>
              <p>The request has been approved and the user has been notified.</p>
              <div className="approval-details">
                <p><strong>Request ID:</strong> {requestData.requestId}</p>
                <p><strong>Budget Code:</strong> {budgetCode}</p>
                <p><strong>Approved by:</strong> Sarah Johnson</p>
              </div>
            </div>
          </div>
        ) : actionTaken === 'rejected' ? (
          <div className="approval-complete">
            <div className="reject-message">
              <span className="reject-icon">❌</span>
              <h3>Request Rejected</h3>
              <p>The request has been rejected and the user has been notified.</p>
              <div className="approval-details">
                <p><strong>Request ID:</strong> {requestData.requestId}</p>
                <p><strong>Rejected by:</strong> Sarah Johnson</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="approval-card">
            <div className="card-header">
              <h3>🔔 New Approval Request</h3>
              <span className="priority-badge">Normal Priority</span>
            </div>

            <div className="request-info">
              <div className="info-section">
                <h4>Request Details</h4>
                <div className="info-grid">
                  <div className="info-item">
                    <span className="label">Request ID:</span>
                    <span className="value">{requestData.requestId}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Requested by:</span>
                    <span className="value">John Smith</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Department:</span>
                    <span className="value">Engineering</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Date:</span>
                    <span className="value">{new Date().toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              <div className="info-section">
                <h4>VM Configuration</h4>
                <div className="config-details">
                  <div className="config-item">
                    <span className="config-icon">💻</span>
                    <div>
                      <div className="config-label">Operating System</div>
                      <div className="config-value">{getOsLabel(requestData.os)}</div>
                    </div>
                  </div>
                  <div className="config-item">
                    <span className="config-icon">⚙️</span>
                    <div>
                      <div className="config-label">VM Size</div>
                      <div className="config-value">{getSizeLabel(requestData.size)}</div>
                    </div>
                  </div>
                  <div className="config-item">
                    <span className="config-icon">💰</span>
                    <div>
                      <div className="config-label">Monthly Cost</div>
                      <div className="config-value cost">${requestData.cost}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="info-section">
                <h4>Budget Assignment</h4>
                <div className="budget-input-group">
                  <label htmlFor="budgetCode">Budget Code *</label>
                  <input
                    id="budgetCode"
                    type="text"
                    placeholder="e.g., ENG-2024-Q1-INFRA"
                    value={budgetCode}
                    onChange={(e) => setBudgetCode(e.target.value)}
                    className="budget-input"
                  />
                  <small>Required for financial accountability and tracking</small>
                </div>
              </div>
            </div>

            <div className="approval-actions">
              <button className="btn-reject" onClick={handleReject}>
                ✗ Reject
              </button>
              <button className="btn-approve" onClick={handleApprove}>
                ✓ Approve Request
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagerApproval;

